namespace $ { $mol_style_attach( "bog/blitz/lobby/game/timer/timer.view.css",
 "@keyframes bog_blitz_timer_shrink {\n\tfrom { width: 100%; }\n\tto { width: 0%; }\n}\n"
) }